import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=eab86602&scoped=true&"
import script from "./forum.vue?vue&type=script&lang=js&"
export * from "./forum.vue?vue&type=script&lang=js&"
import style0 from "./forum.vue?vue&type=style&index=0&id=eab86602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab86602",
  null
  
)

export default component.exports